import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import React from 'react';
import compact from 'lodash/compact';
import { v4 as uuid } from 'uuid';
import { rule, each } from 'instructure-validations';
import { RichContentRenderer } from '@instructure/quiz-rce';
import { ORDERING_SLUG } from '../../interaction_slugs';
import InteractionType from '../InteractionType';
import { noDuplicatesMessage, presenceMessage } from '../../util/validationHelpers';
import t from '@instructure/quiz-i18n/es/format-message';
var OrderingInteractionType = /*#__PURE__*/function (_InteractionType) {
  function OrderingInteractionType(obj) {
    var _this;
    _classCallCheck(this, OrderingInteractionType);
    _this = _callSuper(this, OrderingInteractionType);
    _defineProperty(_this, "slug", ORDERING_SLUG);
    _defineProperty(_this, "translatedName", t('Ordering'));
    _defineProperty(_this, "defaultProperties", {
      includeLabels: true,
      displayAnswersParagraph: false,
      topLabel: '',
      bottomLabel: ''
    });
    _defineProperty(_this, "getDefaultInteractionData", function () {
      var choiceIdA = uuid();
      var choiceIdB = uuid();
      var choiceIdC = uuid();
      var choiceIdD = uuid();
      return {
        itemBody: '',
        choices: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, choiceIdA, {
          id: choiceIdA,
          itemBody: ''
        }), choiceIdB, {
          id: choiceIdB,
          itemBody: ''
        }), choiceIdC, {
          id: choiceIdC,
          itemBody: ''
        }), choiceIdD, {
          id: choiceIdD,
          itemBody: ''
        })
      };
    });
    _defineProperty(_this, "getDefaultScoringData", function (intData) {
      return {
        value: Object.keys(intData.choices).map(function (uuid) {
          return uuid;
        })
      };
    });
    _defineProperty(_this, "getRenderedResponse", function (responseValue) {
      var interactionData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        choices: {}
      };
      return compact(responseValue.map(function (id) {
        var choice = interactionData.choices[id];
        if (choice !== void 0) {
          return /*#__PURE__*/React.createElement(RichContentRenderer, {
            key: id,
            content: choice.itemBody
          });
        } else {
          return null;
        }
      }));
    });
    _superPropGet((_this, OrderingInteractionType), "initializeProps", _this, 3)([obj]);
    return _this;
  }
  _inherits(OrderingInteractionType, _InteractionType);
  return _createClass(OrderingInteractionType, [{
    key: "getDefaultUserResponse",
    value: function getDefaultUserResponse(intData) {
      return {
        value: intData.shuffledOrder || Object.keys(intData.choices)
      };
    }
  }], [{
    key: "validations",
    value: function validations() {
      return {
        interactionData: {
          choices: [each({
            itemBody: [rule('presence', {
              message: presenceMessage(t('Choice'))
            })]
          }), rule('noDuplicates', {
            field: 'itemBody',
            message: noDuplicatesMessage(t('Choice'))
          })]
        }
      };
    }
  }]);
}(InteractionType);
export { OrderingInteractionType as default };